module.exports = __webpack_public_path__ + "static/media/about-bg.1046fc15.jpg";